import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { Card } from "@vega-core/components/shadcn/card";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";
import { SettingsSectionLayout } from "@vega-modules/scenes/Settings/components/SettingsSectionLayout";

const VEGA_SUPPORT_PORTAL_URL =
  "https://vegainvestments.atlassian.net/servicedesk/customer/portals";

export const SupportPage = () => {
  const {
    contacts: { helpEmail = "" },
  } = usePublicConfig();
  const { featureFlag } = useFeatureFlag();
  const isPlatformQuestionsEnabled =
    featureFlag[FeatureFlag.GP_SUPPORT_PLATFORM_QUESTIONS];

  if (isPlatformQuestionsEnabled) {
    return (
      <SettingsSectionLayout title={m.titles_support()}>
        <div className="flex flex-col gap-4">
          <Card
            className="px-6 py-4"
            data-testid="support-tile-internal-questions"
            noShadow
          >
            <div className="py-3">
              <p className="body-base-medium">
                {m.settings_support_internalQuestions_title()}
              </p>
              <p className="body-small-regular py-1">
                {m.settings_support_internalQuestions_body_0()}{" "}
                <a
                  className="text-text/interactive underline"
                  href={`mailto:${helpEmail}`}
                >
                  {helpEmail}
                </a>{" "}
                {m.settings_support_internalQuestions_body_1()}
              </p>
            </div>
          </Card>
          <Card
            className="px-6 py-4"
            data-testid="support-tile-platform-questions"
            noShadow
          >
            <div className="py-3">
              <p className="body-base-medium">
                {m.settings_support_platformQuestions_title()}
              </p>
              <p className="body-small-regular py-1">
                {m.settings_support_platformQuestions_body()}{" "}
                <a
                  className="text-text/interactive underline"
                  href={VEGA_SUPPORT_PORTAL_URL}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {m.settings_support_platformQuestions_linkLabel()}
                </a>
              </p>
            </div>
          </Card>
        </div>
      </SettingsSectionLayout>
    );
  }

  return (
    <SettingsSectionLayout title={m.titles_support()}>
      <Card className="px-6 py-4" noShadow>
        <div className="py-3">
          <p className="body-base-medium">{m.settings_needAnyHelp()}</p>
          <p className="body-small-regular py-1">
            {m.settings_haveAnyIssuesPleaseRe()}{" "}
            <a
              className="text-text/interactive underline"
              href={`mailto:${helpEmail}`}
            >
              {helpEmail}
            </a>{" "}
            {m.settings_forHelp()}
          </p>
        </div>
      </Card>
    </SettingsSectionLayout>
  );
};
